import { computed, makeObservable } from "mobx";
import { MrbBaseListViewStore } from "mrb/core";
import { MrbGridViewStore } from "mrb/components/grid";
import { httpStatusCodes } from "mrb/core/constants";
import { TorahAnytimeTopicsFilter } from "application/torah-anytime/filters";
import { map } from "lodash";

class TorahAnytimeSelectTopicsViewStore extends MrbBaseListViewStore {
    _abortController = null;

    @computed get isTopicSelectionEmpty() {
        return this.torahAnytimeSelectionViewStore.selectedTopics.length === 0;
    }

    constructor(rootStore, { routeStore, torahAnytimeSelectionViewStore }) {
        super(rootStore, {
            queryConfig: {
                filter: new TorahAnytimeTopicsFilter(),
            },
        });
        makeObservable(this);
        this.routeStore = routeStore;
        this.torahAnytimeSelectionViewStore = torahAnytimeSelectionViewStore;

        this.selectAllTopics = this.selectAllTopics.bind(this);
        this.clearSelection = this.clearSelection.bind(this);

        this.setGridStore(
            new MrbGridViewStore(this.rootStore, this.queryUtility, {
                onCellClick: (item) => this.onClickCellItem(item),
            })
        );

        this.reaction(
            () => (this.queryUtility.filter.search || "").trim(),
            () => {
                this.queryUtility.fetch();
            },
            {
                delay: 300,
            }
        );
    }

    onInit() {
        return this.queryUtility.initialize(true, true);
    }

    find(params) {
        this.abortExistingRequest();
        this._abortController = new AbortController();
        return this.routeStore.findTopics(params, this._abortController);
    }

    abortExistingRequest() {
        if (this._abortController) {
            this._abortController.abort();
        }
    }

    async selectAllTopics() {
        try {
            this.loaderStore.suspend();
            const topicIds = await this.routeStore.getAllTopics();
            const topics = map(topicIds, (topicId) => {
                return { id: topicId };
            });

            if (topicIds.length > 0) {
                this.torahAnytimeSelectionViewStore.selectTopics(topics);
            }
        } catch (error) {
            this.rootStore.notificationStore.error("Error while selecting all topics");
        } finally {
            this.loaderStore.resume();
        }
    }

    clearSelection() {
        this.torahAnytimeSelectionViewStore.clearSelectedTopics();
    }

    onFetchError(error) {
        if (error && error.statusCode === httpStatusCodes.CanceledRequest) {
            return;
        }
        this.rootStore.notificationStore.error(
            "Unexpected error occurred while trying to load content. Please contact the support team.",
            error
        );
    }

    onDestroy() {
        this.abortExistingRequest();
    }
}

export default TorahAnytimeSelectTopicsViewStore;
